import type {
  AnalyticsSummary,
  ProductCategoriesResponse,
  ProjectsByEmployeeQuery,
  ProjectsByEmployeeResponse,
  ProjectsOverTimeQuery,
  ProjectsOverTimeResponse,
  RevenueByMonthQuery,
  RevenueByMonthResponse,
  TopClientsQuery,
  TopClientsResponse,
} from '@kreart/shared';
import { api } from '@/lib/api';

function qs(params: Record<string, string | number | undefined>): string {
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== null) p.set(k, String(v));
  }
  const s = p.toString();
  return s ? `?${s}` : '';
}

export const analyticsApi = {
  summary: () => api.get<AnalyticsSummary>('/analytics/summary'),
  projectsOverTime: (q: ProjectsOverTimeQuery) =>
    api.get<ProjectsOverTimeResponse>(`/analytics/projects-over-time${qs({ months: q.months })}`),
  revenueByMonth: (q: RevenueByMonthQuery) =>
    api.get<RevenueByMonthResponse>(`/analytics/revenue-by-month${qs({ months: q.months })}`),
  topClients: (q: TopClientsQuery) =>
    api.get<TopClientsResponse>(`/analytics/top-clients${qs({ limit: q.limit })}`),
  projectsByEmployee: (q: ProjectsByEmployeeQuery) =>
    api.get<ProjectsByEmployeeResponse>(`/analytics/projects-by-employee${qs({ limit: q.limit })}`),
  productCategories: () => api.get<ProductCategoriesResponse>('/analytics/product-categories'),
};
